import React from 'react';

import styles from './profileSectionVisibilityTagStyles';

import Icon from 'buyside/components/presentation/Icon/icon';

const ProfileSectionVisibilityTag = ({ icon, visibility }) => (
  <span className={styles.profileSectionVisbilityTag}>
    <Icon type={icon} />
    Only Visible to&nbsp;
    <strong>{visibility}</strong>
  </span>
);

export default ProfileSectionVisibilityTag;
